<template>

  <div class="group" :ref="refs[builder.hardware.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.hardware.fieldName}Title`">
      <div class="group-title">Choose your hardware options.</div>
    </div>

    <Selector
      :key=builder.hardware.fieldName
      :field-name=builder.hardware.fieldName
      :display-type=builder.hardware.displayType
      :options=builder.hardware.options
      :selected=builder.currentItem.specs[builder.hardware.fieldName]
      options-source="hardwareOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.boards.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.boards.fieldName}Title`">
      <div class="group-title">Choose your board finish.</div>
    </div>

    <Selector
      :key=builder.boards.fieldName
      :field-name=builder.boards.fieldName
      :display-type=builder.boards.displayType
      :options=builder.boards.options
      :selected=builder.currentItem.specs[builder.boards.fieldName]
      options-source="boardsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.depths.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.depths.fieldName}Title`">
      <div class="group-title">Choose your depth.</div>
    </div>

    <Selector
      :key=builder.depths.fieldName
      :field-name=builder.depths.fieldName
      :display-type=builder.depths.displayType
      :options=builder.depths.options
      :selected=builder.currentItem.specs[builder.depths.fieldName]
      options-source="depthsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.addRails.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.addRails.fieldName}Title`">
      <div class="group-title">Would you like any additional hanging rails?</div>
      <div class="group-help">Supplied at 1200mm to be cut to size</div>
    </div>

    <Selector
      :key=builder.addRails.fieldName
      :field-name=builder.addRails.fieldName
      :display-type=builder.addRails.displayType
      :options=builder.addRails.options
      :selected=builder.currentItem.specs[builder.addRails.fieldName]
      options-source="addRailsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.addShelves.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.addShelves.fieldName}Title`">
      <div class="group-title">Would you like any additional shelves?</div>
      <div class="group-help">Supplied at 1200mm to be cut to size</div>
    </div>

    <Selector
      :key=builder.addShelves.fieldName
      :field-name=builder.addShelves.fieldName
      :display-type=builder.addShelves.displayType
      :options=builder.addShelves.options
      :selected=builder.currentItem.specs[builder.addShelves.fieldName]
      options-source="addShelvesOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs['LabelGroup']">

    <div class="group-header" :id="`LabelTitle`">
      <div class="group-title">Label your wardrobe</div>
      <div class="group-help">Maximum 30 characters</div>
    </div>

    <Text-Input
    key="label"
    field-label="label"
    field-name="label"
    :init-value=builder.currentItem.label
    :init-touched="false"
    :placeholder="`Wardrobe ${builder.currentItem.ref}`"
    :maxlength="30"
    @update-value="updateProp"
    ></Text-Input>

  </div>

</template>

<script setup>

import { computed, ref, onMounted } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);
}

function updateProp(prop, val) {
  builder.setCurrentItemProp(prop, val);
}

// init refs
let refHandles = [
  'LabelGroup',
  builder.hardware.fieldName + 'Group',
  builder.boards.fieldName + 'Group',
  builder.depths.fieldName + 'Group',
  builder.addRails.fieldName + 'Group',
  builder.addShelves.fieldName + 'Group',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>
